import { useMutation } from "@apollo/client";
import { Grid, Tooltip } from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { useContext } from "react";
import { ErrorAlert } from "../../../../alerts/errorAlert";
import { SuccessfulAlert } from "../../../../alerts/successAlerts";
import { WarningAlert } from "../../../../alerts/WarningAlert";
import {
  GET_USERS_BY_ID,
  UPDATE_USERS,
} from "../../../../Querys/querys";
import { postFileAWS } from "../../../../services/candidateService";
import DefaultImage from "../../../../assets/svg/icono-subir-archivo-azul.svg";
import CollaboratorContext, {Types} from "../../../../context/CollaboratorContext/CollaboratorContext";
import { updateCollaborator } from "../../../../helpers/Collaborator/Collaborator";

withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 1000,
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const File_Helper = ({
  name,
  accept = ".pdf",
  parametrofrom = "",
  idUsr = "",
  image = DefaultImage,
  remove_file = false,
  disabled = false,
  setArchives,
  archives = [],
  section,
}: any) => {
  const { state, dispatch } = useContext(CollaboratorContext);
  const [updateColaboradores] = useMutation(UPDATE_USERS, {
    refetchQueries: [
      {
        query: GET_USERS_BY_ID,
        variables: { getUsersId: state.collaborator.id },
      },
    ],
  });

  if (accept === ".jpg" || accept === ".png" || accept === ".jpeg") {
    accept = "image/*";
  }

  const uploadFileAws = async (e: any): Promise<void> => {
    dispatch({
      type: Types.LOAD_DATA,
      payload: {
        loading:true
      }
    });
    let result = await postFileAWS(
      e,
      idUsr,
      parametrofrom,
      name,
      remove_file,
      section
    );
    //if result is a string
    
    if ("URL" in result) {
      if (result.name === "DocumentosParaFirma") {
        state.collaborator["CartaOferta"] = result.id;
      } else {
        state.collaborator[result.name] = result.id;
      }

      //comparate archives with result and if exist update it
      let archive = archives.find(
        (archive: any) => archive.name === result.name
      );
      if (archive) {
        //delete index where archives name is the same as result name
        let index = archives.indexOf(archive);
        archives.splice(index, 1);
        //add result to archives
        archives.push(result);
        //update state
        setArchives(archives);
        //updateCollaborator(state.collaborator, dispatch);
      }
      //if not exist add it
      else {
        setArchives([...archives, result]);
      }
      
      if (result.processFlag_1) {
        await updateColaboradores({
          variables: {
            updateUsersId: state.collaborator?.id,
            input: {},
            process: {
              tab: "expedient",
              section: "section_1",
            },
          },
        });
      }
      if (result.processFlag_2) {
        await updateColaboradores({
          variables: {
            updateUsersId: state.collaborator?.id,
            input: {},
            process: {
              tab: "expedient",
              section: "section_2",
            },
          },
        });
      }
      if (result.processFlag_3) {
        await updateColaboradores({
          variables: {
            updateUsersId: state.collaborator?.id,
            input: {},
            process: {
              tab: "expedient",
              section: "section_3",
            },
          },
        });
      }
      if(result.name === 'CartaGMM_PDF' || result.name === "AvisoRetencion_PDF" || result.name === "AGREEMENT_PDF" || result.name === "CartaOfertaFirmada"){
        archives.push(result);
        state.collaborator.archive = archives;
      }
      updateCollaborator(state.collaborator, dispatch);
      await SuccessfulAlert({ text: "Archivo actualizado exitosamente" });
    } else await ErrorAlert({ text: "Archivo no agregado" });
  };

  const deleteFile = async (e: any): Promise<void> => {
    
    let result = await WarningAlert({
      text: "¿Seguro que deseas eliminar el archivo?",
      showDenyButton: true,
    });
    if (result.isConfirmed) {
      dispatch({
        type: Types.LOAD_DATA,
        payload: {
          loading:true
        }
      });
      let result = await postFileAWS(
        e,
        idUsr,
        parametrofrom,
        name,
        remove_file,
        section
      );
      
      if (result) {
        setArchives(result.archives);
      } else {
        setArchives([]);
      }
      state.collaborator[result.name] = null;
      updateCollaborator(state.collaborator, dispatch);

      SuccessfulAlert({ text: "Archivo eliminado exitosamente" });
    } else await ErrorAlert({ text: "Archivo no eliminado" });
  };

  return (
    <Grid>
      <label className="">
        {remove_file ? (
          <input
            type="file"
            name={name}
            accept={accept}
            disabled={disabled}
            onClick={(e) => {
              e.preventDefault();
              deleteFile(e);
            }}
          />
        ) : (
          <input
            type="file"
            name={name}
            accept={accept}
            disabled={disabled}
            onChange={(e) => uploadFileAws(e)}
          />
        )}
        <img src={image} alt="file upload" className={disabled ? "" : "image-file"} />
      </label>
    </Grid>
  );
};

export default File_Helper;
